import { Card } from "react-bootstrap";
import * as React from 'react';
import { translateService, Translate } from "../../services/TranslateService";
import { IVehicleSearch } from "../../interfaces/VehicleSearch";
import styles from "./VehicleSearch.module.scss";
import CustomTooltip from "../CustomTooltip";
import VehicleDetails from "./VehicleDetails";
import { useSelector } from "react-redux";
import { baseOnSalesPrice, basePrice, discountValue as calculateDiscountValue } from "../MakeReservation/pricingCalculations";
import { cx, floorCents, priceFormat } from "../MakeReservation/util";
import { useInView } from "react-intersection-observer";
import {GlobalStore} from "../../reduxStore";
import {VehicleImageSwiper} from "./VehicleImageSwiper";
import {useContext, useEffect, useState} from "react";
import {DataContext} from "../../contexts/dataContext";
import Modal from "react-modal";
import moment from "moment";
import axios from "axios";
import CalendarComponent from "./reservedTable";
import {Rating} from "@mui/material";
import {VipCodeVehicles} from "./VipCodeVehicles";
import {cStylesPaymentCreatedRes} from "../../CustomModalStyles";
import {scrollToElementWithOffset} from "../../GetUrlParams";
import { buildVehicleItem } from "../../services/ga4Ecommerce";

type SetDetailsVisibleFunctionI = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
interface VehicleResultProps {
  vehicle: IVehicleSearch;
  selectVehicle: Function;
  setRedirect: Function | null;
  totalPrice?: number;
  detailsVisible:boolean;
  setDetailsVisible: SetDetailsVisibleFunctionI;
  discountValue?: number;
  displaySticky?: boolean
  setBusy?: Function;
  discount?: null |  number;
  stars?: number
  noVat: boolean
}

interface PriceDisplayProps {
  totalPrice: number;
  discount: number ;
  displaySticky: boolean;
  available?: boolean;
  children?: React.ReactNode;
  pointsApplied?: number;
  isStartingPrice: boolean;
  noVatPrices: boolean;
  changeNoVatPrices: Function;
}

export const PriceDisplay = ({totalPrice, discount, displaySticky=false, available=true, pointsApplied, isStartingPrice, noVatPrices, changeNoVatPrices, children}:PriceDisplayProps) => {
  return <>
    <div className={cx(displaySticky ? 'flex-column align-items-center justify-content-center' : 'flex-column align-items-center justify-content-center', 'd-flex justify-content-around ')} style={{width: 'fit-content'}}>
      {children}


      { isStartingPrice ? <i> {translateService.translate('vehicleSearch1.pricesStartingAt')} </i> : null }

      {(discount > 0 ) &&
          <div className={cx(styles.priceH4,styles.preferDiscountPrice)}>
            {priceFormat(totalPrice)} €
          </div>}
      <div className={styles.priceH4}>
        {pointsApplied ?
            <div className={styles.includeVat} style={{padding: 5}} >
              {translateService.translate('payment.priceAfterPointsApplied')}
            </div> : null}
        {!available ?
            <span className={styles.reservedText}><Translate content='vehicleSearch.reserved' /></span>
            : discount ?
                priceFormat(!pointsApplied ? totalPrice - discount :
                    (totalPrice - discount - pointsApplied < 0 ? 0 :
                        floorCents(totalPrice - discount - pointsApplied) ))+' € '
                : priceFormat(!pointsApplied ? totalPrice :
                (totalPrice - pointsApplied  < 0 ? 0 : floorCents(totalPrice - pointsApplied)))+' € '
        }
      </div>
      <div className={cx(styles.includeVat, styles.includeVatClickable)}
           onClick={() => {changeNoVatPrices()}}>
        <Translate
            with={{type: noVatPrices ? translateService.translate('vehicleSearch.vatPercent0')
                  : translateService.translate('vehicleSearch.vatPercent25')}}
            content='vehicleSearch.vatIncluded'/>
        <span className={styles.vatChangeIcon}>⇄</span>
      </div>
    </div>
  </>
}

const VehicleResult = (({ stars, vehicle, noVat, selectVehicle, totalPrice = vehicle.onsale ? baseOnSalesPrice(vehicle, noVat) : basePrice(vehicle, noVat), detailsVisible,
                          setDetailsVisible, discountValue=calculateDiscountValue(vehicle!, noVat), setRedirect=null, displaySticky=false, setBusy}: VehicleResultProps) => {
  const dataContext = useContext(DataContext);
  const language = useSelector((state: GlobalStore) => state.chauffeurReducer.deviceLanguage);
  const reserved = !vehicle.availabilityData?.available;
  const [refFromScroll, refFromScrollVisible] = useInView();
  let pricingDataType = dataContext.noVatPrices ? vehicle.pricingDataNoVat : vehicle.pricingData;
  const couponValid = ((dataContext.storedCoupon?.valid && pricingDataType.coupon !== null)
      && !vehicle?.onsale && vehicle?.extraOnsales?.extra !== 1 && !vehicle?.privateData?.private);
  let price = totalPrice;
  const isVipVehicle = vehicle.privateData?.private;
  let discount = couponValid ? discountValue : vehicle.onsale ? ((1.0-vehicle.onsale.discountmultiplier)*vehicle.onsale.price)/100 : 0;
  const [vipCodeValid, setVipCodeValid] = useState<boolean>(false);
  const [vipCodeCheckOpen, setVipCodeCheckOpen] = useState(false);
  const [reservationTable, setReservationTable] = React.useState<boolean>(false)
  const [reservedSlots, setReservedSlots] = React.useState<any>(undefined);
  const [reservedSlotsMessages, setReservedSlotsMessages] = React.useState<any>(undefined);
  const pointsToBeApplied = dataContext.pointsInEurosToBeApplied && dataContext.pointsInEurosToBeApplied > 0 ?
      dataContext.pointsInEurosToBeApplied : undefined;
  const vehicleCardTitle = vehicle.vehicleModelData.manufacturer + ' ' +
      vehicle.vehicleModelData.name + ' ' +
      (vehicle.vehicleModelData.dimensions.trunkVolume !== 0 ?
          vehicle.vehicleModelData.dimensions.trunkVolume + ' m³' : '');

  Modal.setAppElement('body');

  useEffect(() => {
    if(dataContext.searchParameters?.carId !== null){
      selectVehicle(vehicle)
    }
  },[dataContext.searchParameters?.carId]);


  useEffect(() => {
    if (dataContext.route !== '/makereservation') {
      return;
    }
    let user = dataContext.user;
    if (dataContext.loggedIn) {
      dataContext.changeAddSafeDrivePackage(!!user?.birthDate?.length && !(!!(!user?.noPersonalIdCode && user?.personalIdCodeRecorded)))
    } else if (user?.isForeignCountryChecked && (!user?.personal_id_code?.length || user?.noPersonalIdCode)) {
        dataContext.changeAddSafeDrivePackage(true);
    } else {
      dataContext.changeAddSafeDrivePackage(!!(user?.givenName && !user?.personal_id_code && (user?.birthDate || user?.birthday) && user?.country));
    }
  }, [dataContext.user, dataContext.loggedIn, dataContext.route]);

  const handleDatePicker = () => {
    reservationArr(vehicle.id)
    if (reservationTable) {
      setReservationTable(false)
    } else {
      setReservationTable(true);
      if (!dataContext.oneWayRes) {
        dataContext.sendGa4Event("open_availability_calendar", {
          flow: "a2a",
          surface: "list",
          item_list_id: "a2a_list",
          item_list_name: "A2A Results",
          vehicle_id: vehicle.id
        });        
      } else {
        dataContext.sendGa4Event("open_availability_calendar", {
          flow: "oneway",
          surface: "list",
          item_list_id: "oneway_list",
          item_list_name: "OneWay Results",
          vehicle_id: vehicle.id
        });        
      }
    }
  }

  const reservationArr = async(vehicleId: number) => {
    // parameters axios get
    const start = moment(dataContext.searchParameters?.startDate).format('YYYY-MM-DD')
    const end = moment(dataContext.searchParameters?.endDate).format('YYYY-MM-DD')

    let params = {
      startDate: start,
      startTime: dataContext.searchParameters?.startTime,
      endDate: end,
      endTime: dataContext.searchParameters?.endTime,
      oneWay: dataContext.oneWayRes ? 1 : undefined,
      pickupCity: dataContext.oneWayRes ? dataContext.searchParameters?.pickupCity : undefined
    }

    try{
      if(vehicleId && params) {
        const response = await axios.get(`${dataContext.v3ApiUrl}/anonymous/vehicles/${vehicleId}/reserved-intervals`, {params})
        if (response.data.data.reservedIntervals) {
          setReservedSlots(response.data.data.reservedIntervals);
          if (response.data.data.messageFi && response.data.data.messageEn) {
            setReservedSlotsMessages(language === "en" ? response.data.data.messageEn : response.data.data.messageFi);
          }
        }
      }
    } catch (e){
      if (dataContext.appContext !== "production") console.log(e)
    }
  }

  if (vehicle.onsale) {
    // ensure that the discount is using correct discount type
    discount =  ((1.0-vehicle.onsale.discountmultiplier)*vehicle.onsale.price)/100;
  }

  if ((vehicle.vehicleModelData.ageLimit ?? 18 ) > 18) {
    vehicle.vehicleData.noundertwentyone = true;
  } else {
    vehicle.vehicleData.noundertwentyone = false;
  }

  let fuelType: string;
  if (+vehicle.vehicleData.fuelType === 0)
    fuelType = translateService.translate('vehicleSearch.diesel');
  else if (+vehicle.vehicleData.fuelType === 1)
    fuelType = translateService.translate('vehicleSearch.95E');
  else
    fuelType = translateService.translate('vehicleSearch.electric');

  if (vehicle.vehicleData.hybridity === 'normal')
    fuelType += " - "+ translateService.translate('vehicleSearch.hybrid');
  else if (vehicle.vehicleData.hybridity !== 'none')
    fuelType += " - "+ translateService.translate('vehicleSearch.plugin');

  useEffect(() => {
    if(isVipVehicle && dataContext.validatedVipVehicles && dataContext.validatedVipVehicles.length) {
      if (dataContext.validatedVipVehicles.split(',').includes(vehicle.id.toString())){
        setVipCodeValid(true);
      }
    }
  }, [isVipVehicle, dataContext.validatedVipVehicles, discount])

  const changeTwentyModal = () => {
    dataContext.changeTwentyModal(true)
    if(dataContext.twentyModal){
      dataContext.changeTwentyModal(false)
    }
  }

  function calculatePercentageRange(value:number) {
    // Ensure the value is within the range [0, 100]
    const clampedValue = Math.min(100, Math.max(0, value));
    const roundedValue = Math.round(clampedValue / 20); // return value 0-5
    return roundedValue;
  }

  return <>
    {/*VIP*/}
    <VipCodeVehicles isVipVehicle={isVipVehicle ?? false}
                     setVipCodeValid={setVipCodeValid}
                     vehicle={vehicle} selectVehicle={selectVehicle}
                     vipCodeCheckOpen={vipCodeCheckOpen} setVipCodeCheckOpen={setVipCodeCheckOpen}/>
    {/*Display Sticky Pricing Banner*/}
    {(displaySticky && !refFromScrollVisible ) &&
        <div className={cx(styles.stickyPriceClass, styles.carPriceGreenBackground)}>
          <PriceDisplay totalPrice={price}
                        discount={vehicle.onsale ? discount : discountValue}
                        displaySticky={true}
                        available={vehicle.availabilityData?.available}
                        pointsApplied={pointsToBeApplied}
                        isStartingPrice={!!(dataContext.showingModelsResults && !dataContext.modelId?.length)}
                        noVatPrices={dataContext.noVatPrices}
                        changeNoVatPrices={dataContext.changeNoVatPrices}>
          </PriceDisplay>
        </div>
    }
    <div className={'w-100'}>
      {/* Vehicle Card */}
      <Card className={`card-body mb-2`} style={{padding: "10px"}}>
        <div className={'d-flex flex-lg-row flex-md-row flex-column'}>
          {/* Image Container */}
          <div className={`col-12 col-md-4 col-lg-4 px-0`} style={{height: "170px"}}>
            {/* Images*/}
            <VehicleImageSwiper vehicle={vehicle}/>
            {/*Reserved Banner*/}
            {reserved && !vehicle.totalNumberOfVehicles ?
                <div className={styles.carReserved}>
                  <div className={styles.label} style={{ fontSize: '10px' }}>
                    <Translate content='vehicleSearch.reserved' />
                  </div>
                </div> : null }
            {!dataContext.oneWayRes && !vehicle.totalNumberOfVehicles ?
                <>
                  {(!pricingDataType.withCoupon && pricingDataType.base.unlimitedKilometers !== null &&
                          pricingDataType.base.unlimitedKilometers < 1201 && !reserved) && // show when unlimited kms < 12 euros
                      <div className={styles.discountRibbon}>
                        <div className={styles.label}>
                          <Translate content='vehicleSearch.unlimited' /> km {pricingDataType?.base.unlimitedKilometers / 100} €/<Translate content='vehicleSearch.day' />
                        </div>
                      </div>}
                  {(!pricingDataType.withCoupon && pricingDataType.base.additionalDriver === 0 &&
                          !(pricingDataType.base.unlimitedKilometers < 1201) && !reserved) &&
                      <div className={styles.discountRibbon}>
                        <div className={styles.label}>
                          <Translate content='vehicleSearch.additionalDriver' />  0 €/<Translate content='vehicleSearch.day' />
                        </div>
                      </div>
                  }
                  {(vehicle.vehicleData.class === 0 && !reserved) &&
                     <CustomTooltip className="tooltip-link" zIndex={2}
                       content={translateService.translate('vehicleSearch1.smartSaverDescription')}>
                      <div className={styles.discountRibbon}>
                       <div className={styles.smartSaverLabel}>
                          <Translate content='vehicleSearch1.smartSaver' />
                        </div>
                      </div>
                    </CustomTooltip>
                  }
                </>
                : null }
        
          </div>
          {/* Details Container */}
          <div className={'col-12 col-md-8 col-lg-8 mt-sm-2 pl-lg-2 pl-md-2 px-0 '}>
            <div className={`${styles.carModel} d-flex align-items-center justify-content-between flex-row`}>
              {/* Title */}
              <h2>{vehicleCardTitle}</h2>
              {/* Stars */}
              <div className={'pt-1'}>
                {!vehicle.totalNumberOfVehicles ?
                    <CustomTooltip className="tooltip-link" zIndex={2}
                           content={translateService.translate('vehicleSearch1.starsTooltip')}>
                      <div className={'d-flex pr-1'}>
                        <Rating name="read-only"
                                max={1} // change this to display more stars
                                value={calculatePercentageRange(stars ? stars : 100)}
                                readOnly />
                        <span>{(stars ?? 100)/20}</span>
                      </div>
                    </CustomTooltip > : null }
              </div>
            </div>
            {/* Details with price container */}
            <div className={'d-flex flex-column-reverse flex-md-row-reverse flex-lg-row-reverse align-content-center align-items-center justify-content-between'}>
              <div className={'align-self-baseline banner-label col-12 col-md-4 col-lg-4 px-0'}>
                {/* Reserved */}
                {!reserved ?
                    <div className={`${cx(styles.r24ChildFlex1, dataContext.mobileDevice ? styles.r24PricingBanner : '')} m-`} ng-show="model.onSalesPrice == 0">
                      <div ref={refFromScroll} className={cx(styles.carPriceGreenBackground)}>
                        <PriceDisplay totalPrice={price} discount={vehicle.onsale ? discount : discountValue}
                                      displaySticky={false}
                                      available={true} pointsApplied={pointsToBeApplied}
                                      isStartingPrice={!!(dataContext.showingModelsResults && !dataContext.modelId?.length)}
                                      noVatPrices={dataContext.noVatPrices}
                                      changeNoVatPrices={dataContext.changeNoVatPrices}>
                          {discount && !reserved ?
                              <div className={`${cx(styles.couponRibbon)}`} style={{fontSize:'13px'}}>
                                <strong>
                                  <span><Translate content={'vehicleSearch.discount'}/></span>
                                  &nbsp;{priceFormat(!pointsToBeApplied ? discount : floorCents(discount + pointsToBeApplied))}<span>€</span>
                                </strong>
                              </div> : null
                          }
                        </PriceDisplay>
                      </div>
                      <div className={'d-flex justify-content-center align-items-center flex-column w-100'}>
                        {!vehicle.totalNumberOfVehicles && pricingDataType.base.savingOpportunities.length ?
                            vehicle.vehicleData.class === 0 ?
                                <div ref={refFromScroll} className='text-center' onClick={() => { }}>
                                  <a href={language === 'en' ? "https://www.24rent.fi/en/smartsaver/" : "https://www.24rent.fi/smartsaver-fin/"}
                                     target="_blank" rel="noopener noreferrer"
                                     className={styles.smartSaverLink}>
                                    {translateService.translate('vehicleSearch1.smartSaverLink')}</a>
                                </div>
                                : <CustomTooltip className="tooltip-link" zIndex={2}
                                    content={pricingDataType.base.savingOpportunities}>
                                    <span className={`${cx(styles.rentCheaper)} m-0 w-100 text-center`}>
                                      {translateService.translate('vehicleSearch1.cheaper')}</span>
                                  </CustomTooltip> : null
                        }
                      </div>
                    </div>
                    :
                    <div className={cx(styles.r24ChildFlex1, styles.r24LeftMargin5,
                        dataContext.mobileDevice ? styles.r24PricingBanner : '')} ng-show="model.onSalesPrice == 0">
                      <div ref={refFromScroll} className={cx(styles.carPriceGreenBackground)}>
                        <PriceDisplay totalPrice={price} discount={vehicle.onsale ? discount : discountValue}
                                      displaySticky={false}
                                      available={false} pointsApplied={pointsToBeApplied}
                                      isStartingPrice={!!(dataContext.showingModelsResults && !dataContext.modelId?.length)}
                                      noVatPrices={dataContext.noVatPrices}
                                      changeNoVatPrices={dataContext.changeNoVatPrices}/>
                      </div>
                    </div>
                }
              </div>
              <div className={'pr-2 pl-0 col-12 col-md-8 col-lg-8'}>
                {!(dataContext.showingModelsResults && !dataContext.modelId?.length) ?
                    <div className={styles.carModelNeighborhood}>{vehicle.homeLocationData.neighborhood}</div>
                    : null}

                <div className={styles.infoContainer}>
                  {vehicle.privateData?.private && !vipCodeValid &&
                  !(dataContext.showingModelsResults && !dataContext.modelId?.length) ?
                      <div className={styles.vipAddressContainer}>
                        <img width="23" height="23" className={styles.carFeatureIcon}
                             src={dataContext.rootUrl + '/assets/icons/new/icon-reservation-location-gray.svg'}
                             alt="icon-reservation-location-gray" loading="lazy"/>
                        <span className={styles.vipBlockedAddress}> {dataContext.language === "fi" ? vehicle.privateData.messageFi : vehicle.privateData.messageEn} </span>
                      </div>
                      : <div className={styles.addressContainer}>
                        {!dataContext.oneWayRes ?
                            !vehicle.totalNumberOfVehicles ?
                                <span className='d-flex flex-row'>
                          <img width="23" height="23" className={`${styles.carFeatureIcon} `}
                               src={dataContext.rootUrl + '/assets/icons/new/map-pin-icon.svg'}
                               alt="ap-pin-icon" loading="lazy"/>
                          <div className={'text-wrap'}>
                            <span onClick={() => {
                              let marker = dataContext.mapMarkers.find((marker) => marker.vehicleId === vehicle.id);
                              if(marker){
                                if (marker.inCluster) {
                                  dataContext.changeOpenPopupInCluster(marker.vehicleId);
                                }
                                marker.marker.click();
                              }
                            }} className={styles.carAddress}>
                              {!dataContext.outOfRange ? vehicle.homeLocationData.fullAddress?.replace(vehicle.homeLocationData.postalCode ?? '', '') :
                                  vehicle.homeLocationData.neighborhood + ' ' + vehicle.homeLocationData.city} <b>{Math.round((+vehicle.distance / 1000) * 10) / 10} km</b>
                            </span>
                          </div>
                        </span> : null
                            :
                            <div className={styles.onewayAddresses}>
                          <span className='d-flex flex-row'>
                            <img width="23" height="23" className={styles.carFeatureIcon}
                                 src={dataContext.rootUrl + '/assets/icons/new/search/icon-pickup-location.svg'}
                                 alt="icon-pickup-location" loading="lazy"/>
                            <div className={'text-wrap'}>
                               <span onClick={(e) => {
                                 let marker = dataContext.mapMarkers.find((marker) => marker.vehicleId === vehicle.id);
                                 if(marker){
                                   if (marker.inCluster) {
                                     dataContext.changeOpenPopupInCluster(marker.vehicleId);
                                   }
                                   marker.marker.click();
                                 }}} className={styles.carAddress}> {!dataContext.outOfRange ? vehicle.homeLocationData.fullAddress?.replace(vehicle.homeLocationData.postalCode ?? '', '') :
                                   vehicle.homeLocationData.neighborhood + ' ' + vehicle.homeLocationData.city} <b>{Math.round((+vehicle.distance / 1000) * 10) / 10} km</b></span>
                            </div>
                          </span>
                              <span>
                            <img width="23" height="23" className={styles.carFeatureIcon}
                                 src={dataContext.rootUrl + '/assets/icons/new/search/icon-return-location.svg'}
                                 alt="icon-return-location" loading="lazy"/>
                            <span onClick={(e) => {
                              dataContext.changeShowOneWayReturnLocation(vehicle.id);
                            }}
                                  className={styles.carAddress}>{!dataContext.outOfRange ? vehicle.returnLocationData?.fullAddress :
                                vehicle.returnLocationData?.neighborhood + ' ' + vehicle.returnLocationData?.city + ' ' + vehicle.returnLocationData?.postalCode}</span>
                          </span>
                            </div>
                        }
                      </div>}
                  {vehicle.parkingPermit.valid &&
                      (dataContext.showingModelsResults ? dataContext.modelId?.length : true) &&
                      <div className={styles.r24Parking}>
                        <img width="23" height="23" className={styles.carFeatureIcon}
                             src={dataContext.rootUrl + "/assets/icons/new/search/icon-z-parking-permit.svg"}
                             alt="icon-z-parking-permit" loading="lazy"/>
                        <span className={styles.r24ParkingTxt}> <Translate content={'vehicleSearch.freeParking'}/>{' '}{vehicle.vehicleData.parkingPermitCityName}</span>
                        <a className={`btn btn-sm btn-outline-info ${styles.greenReadMoreButton}`} target="_blank"
                           rel="noopener noreferrer"
                           href={language === 'fi' ? "https://www.24rent.fi/pysakointi-z-luvalla/" :
                               "https://www.24rent.fi/en/parking-with-parking-permit-z/"}>
                          <strong style={{fontSize: '10px'}}><Translate content={'vehicleSearch.readMore'}/>...</strong>
                        </a>
                      </div>}
                  {/*Icons*/}
                  <div className={styles.carFeatureIconsContainer}>
                    <div className={styles.iconAndText}>
                      <CustomTooltip
                          className="tooltip-link"
                          zIndex={2}
                          content={<Translate content={'vehicleSearch.numberOfSeats'}/>}>
                        <img width="23" height="23" className={styles.carFeatureIcon}
                             src={dataContext.rootUrl + "/assets/icons/new/car-feature-icons/icon-car-feature-seats.svg"}
                             alt="icon-car-feature-seats" loading="lazy"/>
                      </CustomTooltip>
                      <span className={styles.baseIconMargin}>{vehicle.vehicleData.seatCount}</span>
                    </div>
                    <div className={styles.iconAndText}>
                      <CustomTooltip
                          className="tooltip-link"
                          zIndex={2}
                          content={<Translate content={'welcomePhase.vehicleInfoModal.transmission'}/>}
                      >
                        <img width="23" height="23" className={styles.carFeatureIcon}
                             src={dataContext.rootUrl + "/assets/icons/new/car-feature-icons/icon-car-feature-gears.svg"}
                             alt="icon-car-feature-gears" loading="lazy"/>
                      </CustomTooltip>
                      <span className={styles.baseIconMargin}>
                    {!vehicle.vehicleData.hasAutomaticTransmission ? <Translate content={'vehicleSearch.manual'}/> :
                        <Translate content={'vehicleSearch.automatic'}/>}
                  </span>
                    </div>
                    <div className={styles.iconAndText}>
                      <CustomTooltip
                          className="tooltip-link"
                          zIndex={2}
                          content={<Translate content={'welcomePhase.vehicleInfoModal.fuel'}/>}
                      >
                        <img width="23" height="23" className={styles.carFeatureIcon}
                             src={dataContext.rootUrl + "/assets/icons/new/car-feature-icons/icon-car-feature-fuel.svg"}
                             alt="icon-car-feature-fuel" loading="lazy"/>
                      </CustomTooltip>
                      <span className={styles.baseIconMargin}>
                    {fuelType}
                        {(vehicle.vehicleData.hybridity === 'normal' || vehicle.vehicleData.hybridity === 'plug-in' || +vehicle.vehicleData.fuelType === 2) &&
                            <span className={styles.r24EcoText}> ECO</span>
                        }
                  </span>
                    </div>
                    {vehicle.vehicleData.hasHandtruck &&
                        <div className={styles.iconAndText}>
                          <CustomTooltip
                              className="tooltip-link"
                              zIndex={2}
                              content={<Translate content={'vehicleSearch.handtruck'}/>}
                          >
                            <img width="23" height="23" className={styles.carFeatureIcon}
                                 src={dataContext.rootUrl + "/assets/icons/new/car-feature-icons/icon-car-feature-handtruck.svg"}
                                 alt="icon-car-feature-handtruck" loading="lazy"/>
                          </CustomTooltip>
                          <span className={styles.baseIconMargin}> <Translate
                              content={'vehicleSearch.handtruck'}/> </span>
                        </div>
                    }

                    {vehicle.vehicleData.hasHitch &&
                        <div className={styles.iconAndText}>
                          <CustomTooltip
                              className="tooltip-link"
                              zIndex={2}
                              content={<Translate content={'vehicleSearch.towingHitch'}/>}
                          >
                            <img width="23" height="23" className={styles.carFeatureIcon}
                                 src={dataContext.rootUrl + "/assets/icons/new/car-feature-icons/icon-car-feature-towbar.svg"}
                                 alt="icon-car-feature-towbar" loading="lazy"/>
                          </CustomTooltip>
                          <span className={styles.baseIconMargin}> {vehicle.vehicleData.hitchPinCount} - <Translate
                              content={'vehicleSearch.pins'}/></span>
                        </div>
                    }
                    {vehicle.vehicleData.noundertwentyone ?
                        <>
                          <div className={styles.iconAndTextUnder21} onClick={() => changeTwentyModal()}>
                            <CustomTooltip
                                className="tooltip-link"
                                zIndex={2}
                                content={<Translate content={'vehicleSearch.noundertwentyone'}/>}
                            >
                              <img width="35" height="35" style={{width: '35px', height: '35px'}}
                                   src={dataContext.rootUrl + "/assets/icons/new/car-feature-icons/icon-car-feature-noundertwntyone.svg"}
                                   alt={translateService.translate('vehicleSearch.noundertwentyone')} loading="lazy"/>
                            </CustomTooltip>
                          </div>
                        </> : null
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <VehicleDetails vehicle={vehicle} detailsVisible={detailsVisible} setDetailsVisible={setDetailsVisible}>
          { dataContext.showingModelsResults && dataContext.route !== '/makereservation' && !dataContext.modelId?.length ?
              <div className={'col-12 px-0 text-center'}>
                <button onClick={() => {
                  dataContext.changeModelId([vehicle.vehicleModelData.id]);
                  let scrollAnchorEle = document.getElementById("scrollAnchor");
                  if (scrollAnchorEle) {scrollToElementWithOffset(scrollAnchorEle, 50)}
                }}
                        className="btn btn-primary btn-outline-primary btn-cta w-100 align-self-end
                rounded-3 font-weight-bold">
                  {vehicle.totalNumberOfVehicles && vehicle.totalNumberOfVehicles > 1 ?
                  <Translate content={'vehicleSearch1.selectVehicleModel'} with={{ num: vehicle.totalNumberOfVehicles ?? '' }}/>
                  : <Translate content={'vehicleSearch1.selectVehicleModelOne'}/> }
                </button>
              </div> :
              <>
                {(setRedirect && !reserved && dataContext.route !== '/makereservation') ?
                    !isVipVehicle || vipCodeValid ?
                        <button onClick={() => {
                          !dataContext.oneWayRes ? 
                              dataContext.sendGa4Event("select_item", {
                                item_list_id: "a2a_list",
                                item_list_name: "A2A Results",
                                selection_surface: "list",
                                items: [buildVehicleItem(vehicle, { noVat })]
                              }) :
                              dataContext.sendGa4Event("select_item", {
                                item_list_id: "oneway_list",
                                item_list_name: "OneWay Results",
                                selection_surface: "list",
                                items: [buildVehicleItem(vehicle, { noVat })]
                              });
                          selectVehicle(vehicle)}}
                                className="btn btn-primary btn-outline-primary btn-cta w-100 align-self-end
                        rounded-3 font-weight-bold">
                          <Translate content={'vehicleSearch.selectCar'}/>
                        </button>
                        :
                        <button onClick={() => {
                          setVipCodeCheckOpen(!vipCodeCheckOpen)
                        }} className="btn btn-primary btn-outline-primary btn-cta w-100 align-self-end
                        rounded-3 font-weight-bold">
                          <Translate content={'vehicleSearch1.privateSelection'}/>
                        </button>
                    : null}
                {reserved &&
                    <button className="btn btn-primary btn-outline-primary btn-cta w-50 align-self-end w-100 font-weight-bold"
                            onClick={handleDatePicker} id='check-available-times'>
                      <Translate content={'vehicleSearch1.reservedSearch'}/>
                    </button>}
              </>
          }
        </VehicleDetails>
        {reservationTable && <Modal isOpen={reservationTable} style={cStylesPaymentCreatedRes}>
          <div>
            <div className={'row'} style={{width: 'inherit', marginTop: "5px", height: '100%'}}>
              <div className={'col-6'}></div>
              <div className={'col-6 d-flex justify-content-end mb-3'}>
                <button className='btn btn-sm btn-primary btn-all'
                        onClick={() => {handleDatePicker()}}> X </button>
              </div>
            </div>
            <CalendarComponent isVisible={reservationTable} reservedIntervals={reservedSlots}
                               vehicleId={vehicle.id.toString()} reservedMessages={reservedSlotsMessages}/>
          </div>
        </Modal>
        }
      </Card>
    </div>
  </>
});

export default VehicleResult;
